export default function ({ store, req }) {
  if (req && req.hostname) {
    store.commit('setHostName', req.get('Host'))
  }
}
